import { render, staticRenderFns } from "./CustomElementForm.vue?vue&type=template&id=1e700211&scoped=true&"
import script from "./CustomElementForm.vue?vue&type=script&lang=js&"
export * from "./CustomElementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e700211",
  null
  
)

export default component.exports